// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"8c4f9173","142":"70651465","199":"a14eb8dd","584":"c80c83fc","731":"0b6e321e","852":"85402c02"}[chunkId] + ".chunk.js";
};